import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';
import {Navigate} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const Contents = lazy(() => import('@/pages/mngt/contents/Contents'));
const ContentsList = lazy(() => import('@/pages/mngt/contents/ContentsList'));
const ContentsOrdr = lazy(() => import('@/pages/mngt/contents/ContentsOrdr'));
const ContentsLayer = lazy(() => import('@/pages/mngt/contents/ContentsLayer'));

const contentsRoutes: RouteObject[] = [
  {
    path: '/mngt/contents',
    element: withSuspense(<Contents />),
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: withSuspense(<ContentsList />)
      },
      {
        path: 'order',
        element: withSuspense(<ContentsOrdr />)
      },
      {
        path: 'layer',
        element: withSuspense(<ContentsLayer />)
      }
    ]
  }
];

export default contentsRoutes;
